export default __webpack_public_path__ + "assets/images/afa27fcee24d6ac783bfbbb9b5ef5aef.png";